<h2 mat-dialog-title>{{ headline }}</h2>
<mat-dialog-content>
    <mat-tab-group>
        <mat-tab label="Lagerbestand">
            <ng-template matTabContent>
                <kiene-kiene-table [tableDescriptor]="lagerTableDescriptor"></kiene-kiene-table>
            </ng-template>
        </mat-tab>
        <mat-tab label="Abgabebelege">
            <ng-template matTabContent>
                <kiene-kiene-table [tableDescriptor]="abgabebelegTableDescriptor"></kiene-kiene-table>
            </ng-template>
        </mat-tab>
    </mat-tab-group>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-stroked-button (click)="downloadLagerExcel()" color="accent">
        <mat-icon>download</mat-icon>
        Excel Lagerbestand
    </button>
    <button mat-stroked-button (click)="downloadAbgabebelegExcel()" color="accent">
        <mat-icon>download</mat-icon>
        Excel Abgabebelege
    </button>
    <button mat-flat-button (click)="dialogRef.close()" color="accent">Schließen</button>
</mat-dialog-actions>
